import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import styles from "../RareRedirect/RareRedirect.module.sass";

import { login } from "../../store/actions";
import { LoadingIndicator } from "colbi_web_ui/lib/components";
import {
    AUTH_CONFIG,
    REACT_APP_SAML_CLIENT_ID,
    REACT_APP_SAML_REDIRECT_URI,
    REACT_APP_SAML_BASE_URL,
    REACT_APP_SSO_BASE_URL,
    REACT_APP_COLBI_THEME,
} from "../../environmentVariables";

import configsByTheme from "../../enums/configsByTheme";

import { Redirect } from "react-router";

import stylesUnauth from "../Unauthorized/Unauthorized.module.sass";

import { ActionButton } from "colbi_web_ui/lib/components/inputs";
import warning from "../../assets/unauthorized.png";
import I18n from "../../I18n";

import Oidc from "oidc-client";
import { parse } from "query-string";

import { UserRoles } from "../../enums/userRoles";
import { decodeUserSession } from "../../utils/utils";

const oidcSettings = {
    ...AUTH_CONFIG,
    authority: REACT_APP_SAML_BASE_URL,
    client_id: REACT_APP_SAML_CLIENT_ID,
    redirect_uri: REACT_APP_SAML_REDIRECT_URI,
    response_type: "code",
};

const userManager = new Oidc.UserManager(oidcSettings);

async function initAuth() {
    const user = await userManager.getUser();
    if (!user) {
        return await userManager.signinRedirect();
    }
}

const SAMLCallback = (props) => {
    const { match, login, user , location} = props;

    const [loginAttempt, setAttempt] = useState(false);
    const [loading, setLoading] = useState(true);

    const locale = match.params.locale || "en";
    const i18n = I18n.use(locale);
    const userInformation = decodeUserSession(user);
    const handleClick = () => {
        window.history.replaceState({}, document.title, "../../");
        const ssoUrl = REACT_APP_SSO_BASE_URL.endsWith("/")
            ? REACT_APP_SSO_BASE_URL.slice(0, -1)
            : REACT_APP_SSO_BASE_URL;

        return (window.location.href = `${ssoUrl}/my-profile`);
    };

    const [appTheme] = useState(
        REACT_APP_COLBI_THEME
            ? REACT_APP_COLBI_THEME.toLocaleLowerCase()
            : document.localStorage.getItem("theme")
            ? document.localStorage.getItem("theme")
            : "sovos",
    );

    // eslint-disable-next-line
    const [loginApplicationName, setApplicationName] = useState(
        configsByTheme(appTheme)["loginApplicationName"],
    );

    // eslint-disable-next-line
    const [localesByAppTheme, setLocales] = useState(configsByTheme(appTheme)["locales"]);

    useEffect(() => {
        setApplicationName(configsByTheme(appTheme)["loginApplicationName"]);
        setLocales(configsByTheme(appTheme)["locales"]);
        const root = document.getElementsByTagName("html")[0];
        root.setAttribute("class", appTheme);
    }, [appTheme]);

    useEffect(() => {
        async function checkAuthAndLoadProfile() {
            const user = await userManager.getUser();

            if (user) {
                login(user.profile.email.toLowerCase(), "", user.profile['sovos:samlEntityId'], {
                    setAttempt: setAttempt,
                });

                setLoading(false);
            } else {
                try {
                    let { profile } = await userManager.signinRedirectCallback();
                    window.history.replaceState(
                        {},
                        document.title,
                        window.location.pathname
                    );
                    login(profile.email.toLowerCase(), "", profile['sovos:samlEntityId'], {
                        setAttempt: setAttempt,
                    });

                    setLoading(!!profile);
                } catch (error) {
                    initAuth();
                }
            }
        }

        checkAuthAndLoadProfile();
        return ()=>{};
    }, [login, loginAttempt]);

    if (loginAttempt && !loading && userInformation) {
        const { redirect } = parse(location.search);
        return (
            <Redirect
                to={
                    redirect || userInformation.role === UserRoles.BACKOFFICE
                        ? `/${locale}/settings/`
                        : `/${locale}/`
                }
            />
        );
    }

    if (loginAttempt && !loading && !userInformation) {
        window.history.replaceState({}, document.title, "../unauthorized");

        return (
            <div className={stylesUnauth["unauthorized-container"]}>
                <img src={warning} alt="Warning" />
                <div>
                    <h2>{i18n`unauthorized`}</h2>
                    <h1 className={stylesUnauth["unauthorized-401"]}>401</h1>
                    <p>{i18n`unauthorized_description`} </p>
                    <ActionButton
                        primary
                        className={stylesUnauth["go-home"]}
                        onClick={() => handleClick()}
                    >
                        {i18n`Home`}
                    </ActionButton>
                </div>
            </div>
        );
    }

    return (
        <div className={styles["backdrop"]}>
            <LoadingIndicator className={`${styles["loading-indicator"]}`} />
        </div>
    );
};

export default connect(({ user }) => ({ user }), { login })(SAMLCallback);
